module.exports = __webpack_public_path__ + "img/graph-paper-notebook_B09B35B19L.ae002d2a.jpg";